import type { DocumentNode } from '@apollo/client';

import type { OutputMapperConfig } from '../OutputMapperEditor/types.ts';

// Config can be a full OutputMapperConfig or an empty object from form default values
export type ConfigValue = OutputMapperConfig | Record<string, never>;

// Type guard to check if config is a valid OutputMapperConfig
export const isValidConfig = (config: ConfigValue | null): config is OutputMapperConfig => {
    return config !== null && 'output_mapping' in config && 'input_types' in config;
};

export type RecordType = 'order' | 'rfq' | 'invoice';

export interface TestRecord {
    id: string;
    createdAt: string;
    sender: string;
    subject: string;
    orderNumber?: string;
    requestNumber?: string;
    invoiceNumber?: string;
    documentNumber?: string;
    channelId: string;
    channelName: string;
}

export interface TestResult {
    success: boolean;
    error?: string;
    mappedOutput?: any;
    mappedOutputCsv?: string | null;
    mappedOutputXml?: string | null;
    mappedOutputTxt?: string | null;
    mappedOutputTemplate?: string | null;
    /** The file name production would use; null without a file name template. */
    fileName?: string | null;
    inputData?: any;
    configName?: string;
    configVersion?: string;
    returnType?: string;
}

export interface OutputMapperTestingConfig {
    fetchTestRecordsQuery: DocumentNode;
    testMappingMutation: DocumentNode;
    getRecordsFromData: (data: any, type: RecordType) => TestRecord[];
    getTestResultFromData: (data: any) => TestResult;
    buildFetchVariables?: (id: string, limit: number) => Record<string, any>;
    buildTestVariables?: (
        recordId: string,
        recordType: RecordType,
        config: OutputMapperConfig | null
    ) => Record<string, any>;
}
